import { Box, chakra, Flex } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';

import config from 'configs/app';
import useNavItems, { isGroupItem } from 'lib/hooks/useNavItems';
import RewardsButton from 'ui/rewards/RewardsButton';
import { CONTENT_MAX_WIDTH } from 'ui/shared/layout/utils';
import NetworkLogo from 'ui/snippets/networkMenu/NetworkLogo';
import NetworkAddToWallet from 'ui/shared/NetworkAddToWallet';
import UserProfileDesktop from 'ui/snippets/user/profile/UserProfileDesktop';
import UserWalletDesktop from 'ui/snippets/user/wallet/UserWalletDesktop';

import TestnetBadge from '../TestnetBadge';
import NavLink from './NavLink';
import NavLinkGroup from './NavLinkGroup';

const NavigationDesktop = () => {
  const { mainNavItems } = useNavItems();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 0);
    };

    window.addEventListener('scroll', handleScroll);
    
    // Cleanup event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Box 
      borderColor="divider" 
      borderBottomWidth={isScrolled ? "1px" : "0px"}
      position="fixed"
      top="0"
      left="0"  
      right="0"
      zIndex="1000"
      width="100%"
      bg={ isScrolled ? 'rgba(255,255,255,0.97)' : 'white' }
      backdropFilter={ isScrolled ? 'blur(12px)' : 'none' }
      transition="all 0.3s ease-in-out"
      boxShadow="0 2px 12px rgba(37,99,235,0.18), 0 1px 4px rgba(0,0,0,0.08)"
      borderRadius={isScrolled ? '0 0 8px 8px' : '0'}
    >
      <Flex
        display={{ base: 'none', lg: 'flex' }}
        alignItems="center"
        px={ 6 }
        py={isScrolled ? 3 : 5}
        maxW={ `${ CONTENT_MAX_WIDTH }px` }
        height={isScrolled ? "68px" : "84px"}
        mx="auto"
      >
        <NetworkLogo isCollapsed={ false } w={{ lg: 'auto' }} maxW="160px"/>
        <TestnetBadge ml={ 3 }/>
        <chakra.nav ml="auto" mr={ config.features.account.isEnabled || config.features.blockchainInteraction.isEnabled ? 8 : 0 }>
          <Flex as="ul" columnGap={ 3 }>
            { mainNavItems.map((item) => {
              if (isGroupItem(item)) {
                return <NavLinkGroup key={ item.text } item={ item }/>;
              } else {
                return <NavLink key={ item.text } item={ item } noIcon py={ 1.5 } w="fit-content"/>;
              }
            }) }
          </Flex>
        </chakra.nav>
        <Flex gap={ 2 } alignItems="center">
          { config.features.rewards.isEnabled && <RewardsButton size="sm"/> }
          <NetworkAddToWallet/>
          {
            (config.features.account.isEnabled && <UserProfileDesktop buttonSize="sm"/>) ||
            (config.features.blockchainInteraction.isEnabled && <UserWalletDesktop buttonSize="sm"/>)
          }
        </Flex>
      </Flex>
    </Box>
  );
};

export default React.memo(NavigationDesktop);